var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',_vm._b({staticClass:"py-0 pr-2 pl-0"},'v-col',_vm.cols,false),[_c('span',{class:_vm.spanClasses},[_vm._v(_vm._s(this._.upperFirst(_vm.$tc(_vm.labelText, 1))))]),(_vm.labelSubText)?_c('span',{staticClass:"label__subtext"},[_vm._v(_vm._s(_vm.$t(_vm.labelSubText)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }